import { applyFunction } from '@intercom/pulse/lib/computed-properties';
import { encodeAttributes } from '@intercom/embercom-composer/lib/attribute-encoding';
export default function (key) {
  return applyFunction(encodeAttributes, key);
}